import React from 'react'

const TextInput = ({
  className,
  placeHolder,
  name,
  value,
  onChange,
  onKeyPress,
  type,
  ariaLabel,
  ariaRequired,
  autoFocus = false,
}) => {
  return (
    <input
      className={className}
      placeholder={placeHolder}
      name={name}
      onChange={onChange}
      value={value}
      type={type}
      autoComplete="off"
      onKeyPress={onKeyPress}
      aria-label={ariaLabel}
      aria-required={ariaRequired}
      autoFocus={autoFocus}
    />
  )
}

export default React.memo(TextInput)
